import React from 'react';
import { motion } from 'framer-motion';
const entries = [{
  date: 'Vor 3,5 Monaten',
  title: 'Das Problem',
  content: `Rocky hatte eine Infektion. Antibiotika halfen schnell. Aber danach: weicher Stuhl, kein Appetit, stumpfes Fell, wenig Energie. 

Der Tierarzt erklärt: die Darmflora ist zerstört. "Das dauert Monate", sagt er. 

Ich will nicht einfach warten.`,
  rotation: '-rotate-1'
}, {
  date: 'Vor 11 Wochen',
  title: 'Die Recherche',
  content: `Ich lese alles über Darmflora bei Hunden. Über Probiotika, Präbiotika, Synbiotika. 

Ich stoße auf ein pflanzliches Futtertopping mit Inulin und Topinambur – natürliche Präbiotika die nützliche Bakterien ernähren und fördern. 

Ich bestelle es sofort.`,
  rotation: 'rotate-1'
}, {
  date: 'Vor 7 Wochen',
  title: 'Die Rückkehr',
  content: `Woche 2: der Stuhl wird fester. 
Woche 3: Rocky frisst wieder mit Appetit. 
Woche 4: er tobt wieder im Garten. 
Woche 6: das Fell glänzt wieder. 

Ich habe meinen Rocky zurück.`,
  rotation: '-rotate-[0.5deg]'
}, {
  date: 'Heute',
  title: 'Unsere Routine',
  content: `Das Topping bleibt. Es ist jetzt Teil unserer täglichen Routine. 

Ich gebe es ihm auch vorbeugend – damit seine Darmflora stark bleibt.`,
  rotation: 'rotate-[0.5deg]'
}];
export function DiarySection() {
  return <section className="w-full px-4 py-8 max-w-3xl mx-auto space-y-12" data-id="element-39">
      {entries.map((entry, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      delay: index * 0.1
    }} className={`bg-paper p-6 md:p-8 rounded-lg shadow-paper border border-brown/10 ${entry.rotation}`} data-id="element-40">
          <div className="border-b border-brown/20 pb-4 mb-4 flex flex-col md:flex-row md:items-baseline md:justify-between gap-2" data-id="element-41">
            <h3 className="font-handwriting text-3xl text-forest font-bold" data-id="element-42">
              {entry.title}
            </h3>
            <span className="font-serif text-sm text-brown/60 italic" data-id="element-43">
              {entry.date}
            </span>
          </div>
          <div className="font-serif text-gray-700 leading-relaxed space-y-4 whitespace-pre-line text-lg" data-id="element-44">
            {entry.content}
          </div>
        </motion.div>)}
    </section>;
}